module.exports = __webpack_public_path__ + "img/newsImg13.c25a387c.png";